// One-shot handoff of a username from the signup form to the login form, for the
// case where the name someone typed turns out to be an existing account — almost
// always their own. Lives in sessionStorage because the login modal is opened
// from a dozen places and only this one has anything to pass; threading an
// argument through AuthWidgetContext would add a field every other caller has to
// ignore.
//
// Read once and cleared, so reopening the login modal later does not resurrect a
// name the visitor has since moved on from.
export const LOGIN_HANDOFF_KEY = 'loginHandoffUsername';

export function takeLoginHandoffUsername(): string | null {
  if (typeof window === 'undefined') return null;
  const value = window.sessionStorage.getItem(LOGIN_HANDOFF_KEY);
  if (value) window.sessionStorage.removeItem(LOGIN_HANDOFF_KEY);
  return value || null;
}
